import React from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { useStore } from 'core/store/';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import Divider from 'core/components/divider';
import { FarmAssociationForm } from '../farm-association-form';

import useStyles from './farm-association-discount-modal.styles';

const FarmAssociationDiscountModal = observer(() => {
  const classes = useStyles();
  const { offer } = useStore();
  const { setShowFarmAssociationModal } = offer;

  const onClose = () => {
    setShowFarmAssociationModal(false);
  };

  return (
    <BaseDialog onClose={onClose} open>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Label type="subtitle" className={classes.title}>
            MO Farm Associations Discount
          </Label>
        </Grid>
        <Grid item xs={12}>
          <Label type="greenSmall">
            A discount is available on owner-occupied policies if named insured is a member of the Cattlemen's
            Association or Soybean Association.
          </Label>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item xs={12} className={classes.formSubtitle}>
          <Label>Associations the member is a part of:</Label>
        </Grid>
        <Grid item xs={12}>
          <FarmAssociationForm />
        </Grid>
      </Grid>
    </BaseDialog>
  );
});

export default FarmAssociationDiscountModal;
